import type { ThemeItem } from '../../../core/domain'

interface AnimalGroup {
  fact: string
  names: string[]
}

const animalGroups: AnimalGroup[] = [
  {
    fact: 'Mammal: a warm-blooded vertebrate whose females produce milk for their young.',
    names: [
      'African Elephant',
      'Asian Elephant',
      'White Rhinoceros',
      'Black Rhinoceros',
      'Hippopotamus',
      'Giraffe',
      'Okapi',
      'Plains Zebra',
      'Mountain Zebra',
      'African Buffalo',
      'American Bison',
      'European Bison',
      'Blue Wildebeest',
      'Impala',
      'Springbok',
      "Thomson's Gazelle",
      'Greater Kudu',
      'Common Eland',
      'Moose',
      'Elk',
      'Reindeer',
      'Red Deer',
      'Roe Deer',
      'Fallow Deer',
      'Wild Boar',
      'Warthog',
      'Bactrian Camel',
      'Dromedary',
      'Llama',
      'Alpaca',
      'Pronghorn',
      'Domestic Yak',
      'Musk Ox',
      'Mountain Goat',
      'Bighorn Sheep',
      'Alpine Ibex',
      'Lion',
      'Tiger',
      'Jaguar',
      'Leopard',
      'Snow Leopard',
      'Cheetah',
      'Cougar',
      'Eurasian Lynx',
      'Bobcat',
      'Caracal',
      'Serval',
      'Gray Wolf',
      'Red Wolf',
      'Coyote',
      'Golden Jackal',
      'African Wild Dog',
      'Red Fox',
      'Arctic Fox',
      'Fennec Fox',
      'Brown Bear',
      'Polar Bear',
      'American Black Bear',
      'Giant Panda',
      'Sloth Bear',
      'Spotted Hyena',
      'Striped Hyena',
      'Meerkat',
      'Raccoon',
      'European Badger',
      'Honey Badger',
      'Wolverine',
      'North American River Otter',
      'Sea Otter',
      'Walrus',
      'Harbor Seal',
      'Gray Seal',
      'Northern Elephant Seal',
      'California Sea Lion',
      'Blue Whale',
      'Humpback Whale',
      'Sperm Whale',
      'Orca',
      'Bottlenose Dolphin',
      'Narwhal',
      'Beluga Whale',
      'West Indian Manatee',
      'Dugong',
      'Gorilla',
      'Chimpanzee',
      'Bonobo',
      'Bornean Orangutan',
      'Siamang',
      'Hamadryas Baboon',
      'Mandrill',
      'Japanese Macaque',
      'Proboscis Monkey',
      'Golden Lion Tamarin',
      'Ring-tailed Lemur',
      'Aye-aye',
      'Koala',
      'Red Kangaroo',
      'Common Wombat',
      'Tasmanian Devil',
      'Virginia Opossum',
      'Platypus',
      'Short-beaked Echidna',
      'Three-toed Sloth',
      'Giant Anteater',
      'Nine-banded Armadillo',
      'Capybara',
      'North American Beaver',
      'North American Porcupine',
      'Chinchilla',
      'Patagonian Mara',
      'European Rabbit',
      'Arctic Hare',
      'Eastern Gray Squirrel',
      'Black-tailed Prairie Dog',
      'Naked Mole-rat',
      'Egyptian Fruit Bat',
      'Vampire Bat',
      'European Hedgehog',
      'Star-nosed Mole',
      'Aardvark'
    ]
  },
  {
    fact: 'Bird: a feathered vertebrate that lays hard-shelled eggs.',
    names: [
      'Common Ostrich',
      'Emu',
      'Southern Cassowary',
      'Greater Rhea',
      'North Island Brown Kiwi',
      'Emperor Penguin',
      'King Penguin',
      'Adelie Penguin',
      'African Penguin',
      'Wandering Albatross',
      'Atlantic Puffin',
      'Brown Pelican',
      'Great Cormorant',
      'Magnificent Frigatebird',
      'Northern Gannet',
      'Great Blue Heron',
      'Great Egret',
      'Shoebill',
      'White Stork',
      'Scarlet Ibis',
      'Roseate Spoonbill',
      'Greater Flamingo',
      'Mute Swan',
      'Canada Goose',
      'Mallard',
      'Mandarin Duck',
      'Wood Duck',
      'Common Eider',
      'Harpy Eagle',
      'Bald Eagle',
      'Golden Eagle',
      'Osprey',
      'Peregrine Falcon',
      'American Kestrel',
      'Red-tailed Hawk',
      'Secretarybird',
      'California Condor',
      'Turkey Vulture',
      'Indian Peafowl',
      'Wild Turkey',
      'Helmeted Guineafowl',
      'Ring-necked Pheasant',
      'Greater Sage-grouse',
      'Sandhill Crane',
      'Common Moorhen',
      'Eurasian Coot',
      'Kori Bustard',
      'Killdeer',
      'Pied Avocet',
      'Black-necked Stilt',
      'Eurasian Oystercatcher',
      'Atlantic Canary',
      'Herring Gull',
      'Arctic Tern',
      'Black Skimmer',
      'Rock Pigeon',
      'Mourning Dove',
      'Victoria Crowned Pigeon',
      'Great Blue Turaco',
      'Common Cuckoo',
      'Greater Roadrunner',
      'Barn Owl',
      'Snowy Owl',
      'Great Horned Owl',
      'Tawny Owl',
      'Common Nighthawk',
      'Ruby-throated Hummingbird',
      'Common Swift',
      'Belted Kingfisher',
      'European Bee-eater',
      'Lilac-breasted Roller',
      'Toco Toucan',
      'Great Hornbill',
      'Pileated Woodpecker',
      'Kea',
      'Kakapo',
      'Sulphur-crested Cockatoo',
      'Scarlet Macaw',
      'African Gray Parrot',
      'Rainbow Lorikeet',
      'Superb Lyrebird',
      'Blue Jay',
      'Eurasian Magpie',
      'Common Raven',
      'Rook',
      'Bird-of-paradise',
      'Satin Bowerbird',
      'Eurasian Skylark',
      'Barn Swallow',
      'Black-capped Chickadee',
      'European Robin',
      'Common Nightingale',
      'Common Blackbird',
      'Northern Mockingbird',
      'European Starling',
      'House Sparrow',
      'American Goldfinch',
      'Northern Cardinal',
      'Red-winged Blackbird',
      'Common Myna'
    ]
  },
  {
    fact: 'Reptile: an ectothermic vertebrate covered mainly in scales or scutes.',
    names: [
      'Komodo Dragon',
      'Green Iguana',
      'Marine Iguana',
      'Gila Monster',
      'Mexican Beaded Lizard',
      'Nile Monitor',
      'Green Anole',
      'Common Basilisk',
      'Panther Chameleon',
      'Tokay Gecko',
      'Blue-tongued Skink',
      'Thorny Devil',
      'Frilled Lizard',
      'Slow Worm',
      'Leatherback Sea Turtle',
      'Green Sea Turtle',
      'Hawksbill Sea Turtle',
      'Loggerhead Sea Turtle',
      'Galapagos Giant Tortoise',
      'African Spurred Tortoise',
      'Common Snapping Turtle',
      'Red-eared Slider',
      'American Alligator',
      'Chinese Alligator',
      'Nile Crocodile',
      'Saltwater Crocodile',
      'Gharial',
      'Spectacled Caiman',
      'King Cobra',
      'Indian Cobra',
      'Black Mamba',
      'Gaboon Viper',
      'Western Diamondback Rattlesnake',
      'Copperhead',
      'Boomslang',
      'Coral Snake',
      'Green Anaconda',
      'Boa Constrictor',
      'Burmese Python',
      'Reticulated Python',
      'Ball Python',
      'Emerald Tree Boa',
      'California Kingsnake',
      'Corn Snake',
      'Garter Snake',
      'Hognose Snake',
      'Yellow-bellied Sea Snake',
      'Tentacled Snake',
      'Tuatara',
      'Mata Mata Turtle'
    ]
  },
  {
    fact: 'Amphibian: a vertebrate whose life cycle commonly includes aquatic and terrestrial stages.',
    names: [
      'Axolotl',
      'Tiger Salamander',
      'Fire Salamander',
      'Japanese Giant Salamander',
      'Chinese Giant Salamander',
      'Hellbender',
      'Alpine Newt',
      'Great Crested Newt',
      'Olm',
      'Two-toed Amphiuma',
      'American Bullfrog',
      'Goliath Frog',
      'Common Frog',
      'Wood Frog',
      'Leopard Frog',
      'African Clawed Frog',
      'Surinam Toad',
      'Cane Toad',
      'Common Toad',
      'Natterjack Toad',
      'Green Tree Frog',
      'Red-eyed Tree Frog',
      "White's Tree Frog",
      'Glass Frog',
      'Golden Poison Frog',
      'Strawberry Poison-dart Frog',
      'Tomato Frog',
      'Purple Frog',
      'Mexican Burrowing Toad',
      'Ringed Caecilian'
    ]
  },
  {
    fact: 'Fish: an aquatic vertebrate that breathes primarily through gills.',
    names: [
      'Great White Shark',
      'Whale Shark',
      'Tiger Shark',
      'Bull Shark',
      'Hammerhead Shark',
      'Shortfin Mako Shark',
      'Nurse Shark',
      'Goblin Shark',
      'Frilled Shark',
      'Greenland Shark',
      'Giant Manta Ray',
      'Southern Stingray',
      'Electric Ray',
      'Smalltooth Sawfish',
      'Spotted Ratfish',
      'Ocean Sunfish',
      'Atlantic Bluefin Tuna',
      'Swordfish',
      'Atlantic Sailfish',
      'Blue Marlin',
      'Barracuda',
      'Tarpon',
      'Atlantic Cod',
      'Haddock',
      'Atlantic Halibut',
      'European Eel',
      'Moray Eel',
      'Electric Eel',
      'Atlantic Salmon',
      'Rainbow Trout',
      'Arctic Char',
      'Northern Pike',
      'Alligator Gar',
      'Arapaima',
      'Coelacanth',
      'Australian Lungfish',
      'Lake Sturgeon',
      'Paddlefish',
      'Red-bellied Piranha',
      'Silver Arowana',
      'Clownfish',
      'Blue Tang',
      'Emperor Angelfish',
      'Butterflyfish',
      'Lionfish',
      'Stonefish',
      'Scorpionfish',
      'Clown Triggerfish',
      'Pufferfish',
      'Porcupinefish',
      'Moorish Idol',
      'Mandarinfish',
      'Royal Gramma',
      'Goby',
      'Seahorse',
      'Leafy Seadragon',
      'Pipefish',
      'Flying Fish',
      'Mudskipper',
      'Archerfish',
      'Four-eyed Fish',
      'Discus',
      'Oscar Fish',
      'Siamese Fighting Fish',
      'Guppy',
      'Goldfish',
      'Common Carp',
      'Koi',
      'Tilapia',
      'Channel Catfish',
      'Red Lionfish',
      'Napoleon Wrasse',
      'Parrotfish',
      'Remora',
      'Anglerfish',
      'Viperfish',
      'Oarfish',
      'Blobfish',
      'Antarctic Icefish',
      'Atlantic Hagfish'
    ]
  },
  {
    fact: 'Invertebrate: an animal without a vertebral column.',
    names: [
      'Giant Pacific Octopus',
      'Common Octopus',
      'Blue-ringed Octopus',
      'Vampire Squid',
      'Giant Squid',
      'Cuttlefish',
      'Chambered Nautilus',
      'Sea Hare',
      'Blue Dragon Sea Slug',
      'Giant Clam',
      'Blue Mussel',
      'Pacific Oyster',
      'Queen Conch',
      'Roman Snail',
      'Banana Slug',
      'Moon Jellyfish',
      "Lion's Mane Jellyfish",
      'Portuguese Man-of-war',
      'Sea Anemone',
      'Brain Coral',
      'Elkhorn Coral',
      'Red Coral',
      'Barrel Sponge',
      'Venus Flower Basket',
      'Crown-of-thorns Starfish',
      'Sunflower Sea Star',
      'Brittle Star',
      'Feather Star',
      'Purple Sea Urchin',
      'Sand Dollar',
      'Sea Cucumber',
      'Horseshoe Crab',
      'Japanese Spider Crab',
      'King Crab',
      'Blue Crab',
      'Ghost Crab',
      'Coconut Crab',
      'American Lobster',
      'Spiny Lobster',
      'Mantis Shrimp',
      'Cleaner Shrimp',
      'Krill',
      'Goose Barnacle',
      'Giant Isopod',
      'Pill Bug',
      'Emperor Scorpion',
      'Deathstalker Scorpion',
      'Goliath Birdeater',
      'Black Widow Spider',
      'Brown Recluse Spider',
      'Golden Silk Orb-weaver',
      'Peacock Spider',
      'Wolf Spider',
      'Jumping Spider',
      'Tailless Whip Scorpion',
      'Harvestman',
      'Deer Tick',
      'Giant Centipede',
      'African Giant Millipede',
      'Monarch Butterfly',
      'Blue Morpho',
      'Swallowtail Butterfly',
      'Painted Lady Butterfly',
      'Luna Moth',
      'Atlas Moth',
      "Death's-head Hawkmoth",
      'Silkworm',
      'Western Honey Bee',
      'Bumblebee',
      'Carpenter Bee',
      'Tarantula Hawk Wasp',
      'Paper Wasp',
      'Bullet Ant',
      'Leafcutter Ant',
      'Army Ant',
      'Termite',
      'Seven-spot Ladybird',
      'Hercules Beetle',
      'Goliath Beetle',
      'Stag Beetle',
      'Dung Beetle',
      'Firefly',
      'Bombardier Beetle',
      'Weevil',
      'Praying Mantis',
      'Walking Stick',
      'Leaf Insect',
      'Desert Locust',
      'Field Cricket',
      'Katydid',
      'Mole Cricket',
      'Emperor Dragonfly',
      'Damselfly',
      'Cicada',
      'Aphid',
      'Lanternfly',
      'Water Strider',
      'Giant Water Bug',
      'Bed Bug',
      'Green Lacewing',
      'Antlion',
      'Earwig',
      'Silverfish',
      'Flea',
      'Mosquito',
      'Horse Fly',
      'Hoverfly',
      'Housefly',
      'Robber Fly',
      'Earthworm',
      'Medicinal Leech',
      'Christmas Tree Worm',
      'Bobbit Worm',
      'Planarian',
      'Tapeworm',
      'Velvet Worm',
      'Water Bear',
      'Rotifer',
      'Hydra',
      'Bryozoan'
    ]
  }
]

export const ANIMAL_ITEMS: ThemeItem[] = animalGroups.flatMap(({ fact, names }) =>
  names.map((name) => ({
    name,
    imageUrl: null,
    fact,
    sourceId: 'wikipedia-search',
    sourcePath: name
  }))
)

if (ANIMAL_ITEMS.length !== 500 || new Set(ANIMAL_ITEMS.map((item) => item.name)).size !== 500) {
  throw new Error('The animal theme must contain exactly 500 uniquely named animals.')
}
